import Swal from "sweetalert2";

export const checkFormik = (
  formikErrors,
  checkFormikErrors,
  setCheckFormikErrors
) => {
  let fieldsWithErrors = [];

  for (let error in formikErrors) {
    fieldsWithErrors = fieldsWithErrors.concat(
      error.toString() === "firstName"
        ? `Όνομα: ${formikErrors[error]}`
        : error.toString() === "lastName"
        ? `<br />Επώνυμο: ${formikErrors[error]}`
        : error.toString() === "middleName"
        ? `<br />Πατρώνυμο: ${formikErrors[error]}`
        : error.toString() === "birthDate"
        ? `<br />Έτος Γέννησης: ${formikErrors[error]}`
        : error.toString() === "gender"
        ? `<br />Φύλο: ${formikErrors[error]}`
        : error.toString() === "personOfContact"
        ? `<br />Πρόσωπο Επικοινωνίας: ${formikErrors[error]}`
        : error.toString() === "phone1"
        ? `<br />Τηλέφωνο 1: ${formikErrors[error]}`
        : error.toString() === "phone2"
        ? `<br />Τηλέφωνο 2: ${formikErrors[error]}`
        : error.toString() === "street"
        ? `<br />Οδός: ${formikErrors[error]}`
        : error.toString() === "number"
        ? `<br />Αριθμός: ${formikErrors[error]}`
        : error.toString() === "floor"
        ? `<br />Όροφος: ${formikErrors[error]}`
        : error.toString() === "postalcode"
        ? `<br />ΤΚ: ${formikErrors[error]}`
        : error.toString() === "municipalityId"
        ? `<br />Δήμος: ${formikErrors[error]}`
        : error.toString() === "tempStreet"
        ? `<br />Οδός (Προσωρινή): ${formikErrors[error]}`
        : error.toString() === "tempNumber"
        ? `<br />Αριθμός (Προσωρινός): ${formikErrors[error]}`
        : error.toString() === "tempFloor"
        ? `<br />Όροφος (Προσωρινός): ${formikErrors[error]}`
        : error.toString() === "tempPostalcode"
        ? `<br />ΤΚ (Προσωρινός): ${formikErrors[error]}`
        : error.toString() === "deviceId"
        ? `<br />Συσκευή: ${formikErrors[error]}`
        : null
    );
  }

  if (Object.keys(formikErrors).length > 0 && checkFormikErrors) {
    Swal.fire({
      title: "Σφάλμα",
      html:
        "<h3>Παρακαλούμε ελέγξτε όλα τα απαιτούμενα πεδία</h3>",
      icon: "warning",
      onAfterClose: () => window.scrollTo({ top: 0, behavior: "smooth" }),
    });
    setCheckFormikErrors(false);
  }
};
